<template lang="pug">
article.beefup.faq-list.bg-white.shadow.mb-4(:class="{ expand: isExpand }")
  .beefup__head.d-flex.justify-content-between.align-items-center(
    @click="expand"
  )
    h4 {{ title }}
    svg-icon(iconClass="arrow_bottom", className="arrow_bottom")

  ul.beefup__body(ref="content")
    li(v-for="(question, index) in questionList", :key="index")
      a(@click="onBtnClick(question.id)") {{ question.title }}
</template>

<script>
import Velocity from "velocity-animate";
export default {
  name: "Faq",
  props: {
    title: String,
    questionList: Array,
  },
  data() {
    return {
      isExpand: false,
    };
  },
  watch: {
    itemList() {
      this.getHeight();
    },
  },
  methods: {
    expand() {
      this.isExpand = !this.isExpand;
      this.getHeight();
    },
    getHeight() {
      if (this.isExpand) {
        //取得元素完整高度
        var height = this.$refs.content.scrollHeight + 20;

        Velocity(
          this.$refs.content,
          { maxHeight: height, opacity: 1 },
          { duration: 500 }
        );
      } else {
        Velocity(
          this.$refs.content,
          { maxHeight: 0, opacity: 0 },
          { duration: 200 }
        );
      }
    },
    onBtnClick(id) {
      this.$emit("toDetail", id);
    },
  },
};
</script>

<style lang="scss" scoped>
.beefup {
  margin: 1em 0;
}
ul.beefup__body {
  max-height: 0;
  overflow: hidden;
  padding: 0;
}
.faq-list .beefup__head::after {
  z-index: 2;
  color: rgba(8, 43, 107, 0.2);
  padding: 5px;
}
.faq-list .beefup__head {
  border-left: #faad00 10px solid;
  font-size: 1.3125rem;
  font-weight: 300;
  color: #082b6b !important;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 20px;
  padding-right: 20px;
  margin: 0;
  cursor: pointer;

  h4 {
    margin-bottom: 0;
  }
}
.faq-list ul li {
  list-style: none;
  margin-left: 0;
}
.faq-list ul li a {
  display: block;
  background-color: rgba(8, 43, 107, 0.05);
  padding: 10px 30px;
}
.faq-list ul li a:hover {
  text-decoration: none;
  color: #fff;
  background-color: rgba(8, 43, 107, 0.5);
}
.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
.arrow_bottom {
  transform: rotate(0);
  transition: all 0.5s;
}
.expand {
  .arrow_bottom {
    transform: rotate(180deg);
    transition: all 0.5s;
  }
}

a {
  cursor: pointer;
}
</style>